import { Heart, Sparkle, Star, Zap } from "lucide-react";
import { DemoForm } from "./DemoForm";
import { Reveal } from "./Reveal";

export function FinalCta() {
  return (
    <section id="demo" className="bg-cream px-6 py-24 lg:px-8">
      <Reveal>
        <div className="relative mx-auto max-w-5xl overflow-hidden rounded-[2rem] bg-cream-deep px-8 py-20 text-center">
          <Heart className="absolute left-10 top-10 text-ink/20" size={22} />
          <Zap className="absolute right-10 top-14 text-ink/20" size={22} />
          <Sparkle className="absolute bottom-14 left-16 text-ink/20" size={22} />
          <Star className="absolute bottom-10 right-14 text-ink/20" size={22} />

          <p className="text-sm font-bold uppercase tracking-widest text-coral">Wara Cards</p>
          <h2 className="mx-auto mt-4 max-w-2xl text-4xl font-extrabold tracking-tight text-ink lg:text-5xl">
            Arrêtez de perdre vos clients
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-ink-soft">
            Chaque jour sans carte de fidélité digitale, c'est des clients qui passent et
            que vous n'avez aucun moyen de rappeler. La démo prend 20 minutes.
          </p>

          <div className="mt-8">
            <DemoForm />
            <a
              href="#faq"
              className="mt-4 inline-block text-sm font-medium text-ink-soft hover:text-ink"
            >
              Préférez lire la FAQ d'abord ? →
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
